export default function GrainOverlay() {
  return (
    <svg className="cp-grain" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <filter id="cp-noise">
        <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" stitchTiles="stitch" />
        <feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 0.5 0" />
      </filter>
      <rect width="100%" height="100%" filter="url(#cp-noise)" />
    </svg>
  )
}
